import { InjectionToken } from '@angular/core';

export interface CloudinaryConfig {
  active: boolean;
  cloudName: string;
  fetchImageUrl: string;
}

export const CLOUDINARY_CONFIG = new InjectionToken<CloudinaryConfig>('CloudinaryConfig');
